import { UniFiCategoryId } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";

import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/door-access/readers-and-intercoms/g3-reader-flex.png";
import type { Product } from "../../types";
import { doorAccessReadersIntercom } from "../product-list-groups/doorAccessReadersIntercom";
import {
  cameraReader,
  directory,
  hand,
  mobileAppAccess,
  nfcCard,
  outdoorReady,
  pinAccess,
  readerPowerMethod,
  touchPassSupport,
  twoWayIntercom,
} from "../properties";

export const g3ReaderFlex: Product = {
  id: "g3ReaderFlex",
  productTitle: "G3 Reader Flex",
  productListGroup: doorAccessReadersIntercom,
  descriptionMaxWidth: 204,
  image: { src: image, width: 200, height: 160 },
  description: "g3ReaderFlex.description",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.DoorAccess}/ua-g3-flex`,
  ],
  storePathParts: {
    category: UniFiChildCategorySlug.DoorAccessReaders,
    productSlug: "ua-g3-flex",
  },
  isNew: true,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: { type: "string", value: '84 x 84 x 40.8 mm\n(3.3 x 3.3 x 1.6")' },
    },
    {
      propertyId: cameraReader.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: twoWayIntercom.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: directory.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: touchPassSupport.id,
      value: {
        type: "string",
        value: "Apple Wallet\nGoogle Wallet",
      },
    },
    {
      propertyId: pinAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: nfcCard.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: mobileAppAccess.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: hand.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: outdoorReady.id,
      value: {
        type: "translation",
        value: "g3ReaderFlex.outdoorReady",
      },
    },
    {
      propertyId: readerPowerMethod.id,
      value: {
        type: "translation",
        value: "readerPowerMethod.poeViaUniFiControlHub",
      },
    },
  ],
};
